'use strict';

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';
import ClienteHeader from './ClienteHeader.jsx';
import NuevaSolicitudDatos from '../../NuevaSolicitudDatos/components/Container.jsx'
import DatosIncorrectos from '../../NuevaSolicitudDatos/components/DatosIncorrectos.jsx'
import TableSolicitudes from './TableSolicitudes.jsx';
import TableCuentas from './TableCuentas.jsx';
import PanelSeleccion from '../../PanelSeleccion/components/Container.jsx';
import DistribucionLimites from '../../DistribucionLimites/components/Container.jsx';

import { GenericModalButton } from 'com-gyf-webcore-userinterfacecomponents';

import Modal from 'react-modal';


class VistaCliente extends Component {
    constructor(props) {
        super(props);
        this.state = {
            OpenModal: false,
            redirect: false,
            modalDatos: false
        }
        this.toggleModal = this.toggleModal.bind(this);
        this.aceptModalCuentas = this.aceptModalCuentas.bind(this);
        this.redirectDatosCorrectos = this.redirectDatosCorrectos.bind(this);
        this.toggleModalDatos = this.toggleModalDatos.bind(this);
        this.modificarSolicitud = this.modificarSolicitud.bind(this);
        this.goToLimits = this.goToLimits.bind(this);
    }

    toggleModal() {
        if (!this.state.OpenModal) {
            this.setState({ OpenModal: true })
        } else {
            this.setState({ OpenModal: false })
        }
    }

    toggleModalDatos() {
        if (!this.state.modalDatos) {
            this.setState({ modalDatos: true })
        } else {
            this.setState({ modalDatos: false })
        }
    }

    aceptModalCuentas() {
        $('#datosIncorrectos').modal('toggle');
    }

    redirectDatosCorrectos() {
        this.setState({ redirect: true })
    }

    modificarSolicitud(solicitud) {
        if (solicitud.SolicitudTipoId == 1) {
            //SOLICITUD TIPO "EMPRESA"
            this.props.loadModificacionSolicitud(solicitud); //CARGA LOS DATOS DE LA SOLICITUD SELECCIONADA EN EL STATE TARJETAS
            this.props.redirectToEmpresa();// REDIRIGE A SOLICITUD
        } else if (solicitud.SolicitudTipoId == 2) {
            //SOLICITUD TIPO "CUENTA"
            if (solicitud.empresa) {
                let empresaSeleccionada = {};
                let empresas = this.props.data.CONSULTA_SOLICITUD_CUENTA_EMPRESA;
                empresas.map(e => { if (e.empresaId == solicitud.empresa) { e.seleccionada = true; empresaSeleccionada = JSON.parse(JSON.stringify(e)) } });
                solicitud.empresaSeleccionada = empresaSeleccionada
            }
            this.props.loadModificacionSolicitud(solicitud); //CARGA LOS DATOS DE LA SOLICITUD SELECCIONADA EN EL STATE TARJETAS
            this.props.redirectToNuevaSolicitudCuenta(); // REDIRIGE A SOLICITUD
        } else if (solicitud.SolicitudTipoId == 3) {
            //SOLICITUD TIPO "ADICIONAL O EXTENSIÓN"
            //VA A INVOCAR LA FUNCIÓN DE AGREGAR ADICIONAL AGREGANDOLE A LAS TARJETAS DE LA CUENTA CORRESPONDIENTE, LAS DE LA SOLICITUD
            let cuentaSeleccionada = {};
            let empresaSeleccionada = {};

            let cuentas = this.props.data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_OTRAS.concat(this.props.data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA);
            let empresas = this.props.data.CONSULTA_SOLICITUD_CUENTA_EMPRESA;

            cuentas.map(c => { if (c.Id == solicitud.cuentaId) cuentaSeleccionada = JSON.parse(JSON.stringify(c)) });
            empresas.map(e => { if (e.Id == cuentaSeleccionada.EmpresaId) empresaSeleccionada = JSON.parse(JSON.stringify(e)) })

            cuentaSeleccionada.Tarjetas = cuentaSeleccionada.Tarjetas.concat(solicitud.Tarjetas);
            cuentaSeleccionada.empresa = empresaSeleccionada;
            cuentaSeleccionada.SolicitudTipoId = 3;
            cuentaSeleccionada.SolicitudAdcionalId = solicitud.solicitudId;

            this.props.nuevaSolicitudAdicional(cuentaSeleccionada);
        }
    }

    goToLimits() {
        this.props.openModalDistribucionLimites();
    }

    componentDidMount() {
        this.props.getScreenData(this.props.currentScope);
        this.props.resetNuevaSolicitudCuenta();
    }

    componentWillUnmount() {
        this.props.resetStateVistaCliente();
    }

    render() {
        const { data, tarjetas } = this.props;

        /*PERMISOS*/
        const permisos = data.consultaSociosFunctionsAllowed && data.consultaSociosFunctionsAllowed;/* tarjetas.claims ? tarjetas.claims.CONSULTASOCIOS : []; */
        const permisoModificacion = permisos ?  permisos.Modificacion : undefined;
        //const permisoConfirmacion = permisos ?  permisos.Confirmacion : undefined;
        const permisoBaja = permisos ?  permisos.Baja : undefined;
        /*FIN PERMISOS*/
        
        let mostrarBotonDistribucionLimites = false;

        //SI ALGUNA CUENTA VISA TIENE ID DE EMPRESA, TIENE QUE HABER UNA EMPRESA OPERATIVA Y CORRESPONDE MOSTRAR EL BOTÓN DE LÍMITES
        Array.isArray(data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA) && data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA.map(cuenta => {
            if (cuenta.empresaId > 0) mostrarBotonDistribucionLimites = true;
        })

        //SE UNEN LAS SOLICITUDES Y TARJETAS TRAIDAS POR LOS SP'S DE VISA Y CABAL PARA MOSTRARLAS EN LAS TABLAS.
        let totalSolicitudes = [];
        let totalTarjetasSolicitudes = [];

        if (this.props.data.CONSULTA_SOLICITUDES_CUENTA && this.props.data.CONSULTA_SOLICITUDES_CUENTA_CABAL) {

            totalSolicitudes = this.props.data.CONSULTA_SOLICITUDES_CUENTA.concat(this.props.data.CONSULTA_SOLICITUDES_CUENTA_CABAL).concat(this.props.data.CONSULTA_SOLICITUDES_CUENTA_MASTER);
        }

        if (this.props.data.CONSULTA_TARJETAS_CABAL && this.props.data.CONSULTA_TARJETAS) {
            totalTarjetasSolicitudes = this.props.data.CONSULTA_TARJETAS.concat(this.props.data.CONSULTA_TARJETAS_CABAL).concat(this.props.data.CONSULTA_TARJETAS_MASTER);
            totalTarjetasSolicitudes = totalTarjetasSolicitudes.filter(solicitud => solicitud.SolicitudEstadoId != 12);
        }

        if (this.state.redirect == true) {
            return <Redirect to={ProcessManager.GetNextStep("VistaCliente", "ROUTE_TO_ADMINISTRADORA")} push />
        }

        if (this.props.data.redirectToCuenta && this.props.tarjetas.tipoEmpresa && this.props.tarjetas.tipoEmpresa.Id && this.props.tarjetas.administradora) {
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudEmpresa", "ROUTE_TO_CUENTA")} push />
        }

        if (this.props.data.redirectToAdicionales && this.props.tarjetas.solicitudCuenta) {
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudAdicional", "ROUTE_TO_NUEVA_SOLICITUD_ADICIONAL")} push />
        }

        if (this.props.data.redirectToEmpresa && this.props.tarjetas.datosSolicitud && this.props.tarjetas.empresaVisaSeleccionada) {
            return <Redirect to={ProcessManager.GetNextStep("VistaCliente", "ROUTE_TO_EMPRESA")} push />
        }

        if (this.props.tarjetas.redirectToCuentaCliente) {
            return <Redirect to={ProcessManager.GetNextStep("VistaCliente", "ROUTE_TO_CUENTA_CLIENTE")} push />
        }
        if (this.props.data.redirectToAvisoViaje) {
            return <Redirect to={ProcessManager.GetNextStep("VistaCliente", "ROUTE_TO_AVISO_VIAJE")} push />
        }
        
        let keyModal = (Array.isArray(data.CONSULTA_SOLICITUDES_CUENTA_CABAL) && Array.isArray(data.CONSULTA_SOLICITUDES_CUENTA_CABAL)) ? data.CONSULTA_SOLICITUDES_CUENTA_CABAL.length + data.CONSULTA_SOLICITUDES_CUENTA.length : 0;
        return (
            <div>
                <div className="col-md-12 bottom-separator-grey ">
                    <div className="row ">
                        <div className="col-md-10 no-gutters">
                            <ClienteHeader datosCliente={data.CONSULTA_SOLICITUD_CUENTA_CLIENTE} cliente={this.props.tarjetas.clienteResultadoBusqueda} />
                        </div>
                        <div className="col-md-2 no-gutters">
                            <GenericModalButton id="btnDataCliente" buttonClass="btn btn-secondary float-right top-separator-xs" type="button" text="Datos Cliente" dataTarget="#soloDatos" />
                        </div>
                    </div>
                </div>
            <div>
                {<div className="col-md-12">
                    <Modal
                        isOpen={this.props.data.modalVisibleLimites}
                        contentLabel="Modal"
                        className={{ base: 'modal-react-example-css' }}
                    >
                        <DistribucionLimites
                            data={this.props.data}
                            globalState={this.props.globalState}
                            guardaDatos={false} //<----- indica si la info se guarda en la BBDD...
                            getDatosFromDB={false} //<----- Se carga con datos de la BBDD y no del store generico al ser true...
                            currentScope={this.props.currentScope}
                            functions={null}
                            cerrarModal={this.props.closeModalDistribucionLimites}
                            actualizarEstadoPantallaInvocadora={this.props.actualizarLimites} //<----- Ejecuta la action que actualiza el estado de la pantalla que lo invoca...
                        />
                    </Modal>
                </div>}
                <div className="col-md-12 no-gutters">
                    {<NuevaSolicitudDatos
                        administradora="VISA"
                        cliente={data.client}
                        toggleModal={this.toggleModal}
                        aceptModalCuentas={this.aceptModalCuentas}
                        redirect={this.redirectDatosCorrectos}
                        key={keyModal > 0 ? "modalDatosCliente" + keyModal : "modalDatosCliente0"}

                    />}
                    {<NuevaSolicitudDatos
                        administradora="VISA"
                        cliente={data.client}
                        toggleModal={this.toggleModalDatos}
                        soloDatos={true}
                        idModal="soloDatos"
                        key={keyModal > 0 ? "modalDatosCliente" + keyModal + "b" : "modalDatosCliente1"}
                    />}
                    <DatosIncorrectos onclick={this.aceptmodalcuentas} />
                </div>
                <div className="col-md-12 no-gutters">
                    <TableSolicitudes modificarSolicitud={this.modificarSolicitud} cambiarEstadoSolicitud={this.props.cambiarEstadoSolicitud} integrantes={totalTarjetasSolicitudes} solicitudesCliente={totalSolicitudes} tarjetas={tarjetas} />
                </div>
                {data.activoPanelSeleccion ? <div className="col-md-12">
                    <PanelSeleccion data={this.props.data} />
                </div>
                    : <div className="col-md-12 no-gutters">
                        <TableCuentas
                            darDeBajaCuenta={this.props.darDeBajaCuenta}
                            seleccionarComponente={this.props.seleccionarComponente}
                            AbrirModuloConsultaOperacionCuenta={this.props.AbrirModuloConsultaOperacionCuenta}
                            openPanelSeleccion={this.props.openPanelSeleccion}
                            tarjetas={data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_INTEGRANTES}
                            cuentasVisa={data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_VISA}
                            cuentasOtras={data.CONSULTA_SOLICITUD_CUENTA_CUENTAS_OTRAS}
                            empresas={data.CONSULTA_SOLICITUD_CUENTA_EMPRESA}
                            nuevaSolicitudAdicional={this.props.nuevaSolicitudAdicional}
                            permisoBaja={permisoBaja} 
                            permisoModificacion={permisoModificacion}
                            redirectToAvisoViaje = {this.props.redirectToAvisoViaje} 
                            />
                    </div>}
                </div>
            </div>
        );
    }
}

export default VistaCliente;